import { Component, Inject, Input } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from "@softline/dynamic";
import {I18nModule} from '@softline/ui-core';

@Component({
    selector: 'soft-field-ok-data-view',
    imports: [CommonModule, I18nModule],
    templateUrl: './artstamm.list-view.html',
    styleUrls: ['./artstamm.list-view.scss']
})
export class ArtstammListView implements FieldOkItemComponent<any>{

  @Input() item: any;

  constructor() {
  }
}
